import {
  FETCH_REFUND_REASON_LIST,
  RESET_REFUND_REASON_LIST,
} from "../../constants/action.constants";

//Storage for data.
const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 10,
  },
};

//Controller for the storage.
const refundReasonListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REFUND_REASON_LIST:
      return { list: action.payload, others: action.others };
    case RESET_REFUND_REASON_LIST:
      return initialState;
    default:
      return state;
  }
};

export default refundReasonListReducer;
